export enum PoolTab {
  LIVE = 'live',
  COMPLETED = 'completed',
  STAKED = 'staked'
}
